import httpManager from "../../../../shared/utils/httpManager";

/**
 * Obtener contacto.
 *
 * @param {Number} id
 * @return {Promise<Object>} Contacto
 */
export async function fetchTypificationsClient(id) {
  const url = `/contacts/clients/${id}/managements/`;
  const response = await httpManager.get(url);

  return response.data;
}
